import { useEffect, useState } from "react";
import Typewriter from 'typewriter-effect';
import Header from "../components/header";
import { SignupModelHelper } from "../data/SignupModel";

export default function Cidade(props: any) {

    const [typed, setTyped] = useState(false);
    const [gender, setGender] = useState('');
    const [cityFilter, setCityFilter] = useState('');

    useEffect(() => {
        const signup = SignupModelHelper.get();
        if (signup) {
            setGender(signup.gender);
        } else {
            document.location = './';
        }
    }, [])

    function setCity(city: string) {
        SignupModelHelper.update({
        });
        document.location = '#/endereco-rua';
    }

    let objCitiesList: any = [
        "São Paulo",
        "Guarulhos",
        "Campinas",
        "São Bernardo do Campo",
        "Santo André",
        "Adamantina",
        "Adolfo",
        "Aguaí",
        "Águas da Prata",
        "Águas de Lindóia",
        "Águas de Santa Bárbara",
        "Águas de São Pedro",
        "Agudos",
        "Alambari",
        "Alfredo Marcondes",
        "Altair",
        "Altinópolis",
        "Alto Alegre",
        "Alumínio",
        "Álvares Florence",
        "Álvares Machado",
        "Álvaro de Carvalho",
        "Alvinlândia",
        "Americana",
        "Américo Brasiliense",
        "Américo de Campos",
        "Amparo",
        "Analândia",
        "Andradina",
        "Angatuba",
        "Anhembi",
        "Anhumas",
        "Aparecida",
        "Aparecida d'Oeste",
        "Apiaí",
        "Araçariguama",
        "Araçatuba",
        "Araçoiaba da Serra",
        "Aramina",
        "Arandu",
        "Arapeí",
        "Araraquara",
        "Araras",
        "Arco-Íris",
        "Arealva",
        "Areias",
        "Areiópolis",
        "Ariranha",
        "Artur Nogueira",
        "Arujá",
        "Aspásia",
        "Assis",
        "Atibaia",
        "Auriflama",
        "Avaí",
        "Avanhandava",
        "Avaré",
        "Bady Bassitt",
        "Balbinos",
        "Bálsamo",
        "Bananal",
        "Barão de Antonina",
        "Barbosa",
        "Bariri",
        "Barra Bonita",
        "Barra do Chapéu",
        "Barra do Turvo",
        "Barretos",
        "Barrinha",
        "Barueri",
        "Bastos",
        "Batatais",
        "Bauru",
        "Bebedouro",
        "Bento de Abreu",
        "Bernardino de Campos",
        "Bertioga",
        "Bilac",
        "Birigui",
        "Biritiba-Mirim",
        "Boa Esperança do Sul",
        "Bocaina",
        "Bofete",
        "Boituva",
        "Bom Jesus dos Perdões",
        "Bom Sucesso de Itararé",
        "Borá",
        "Boracéia",
        "Borborema",
        "Borebi",
        "Botucatu",
        "Bragança Paulista",
        "Braúna",
        "Brejo Alegre",
        "Brodowski",
        "Brotas",
        "Buri",
        "Buritama",
        "Buritizal",
        "Cabrália Paulista",
        "Cabreúva",
        "Caçapava",
        "Cachoeira Paulista",
        "Caconde",
        "Cafelândia",
        "Caiabu",
        "Caieiras",
        "Caiuá",
        "Cajamar",
        "Cajati",
        "Cajobi",
        "Cajuru",
        "Campina do Monte Alegre",
        "Campo Limpo Paulista",
        "Campos do Jordão",
        "Campos Novos Paulista",
        "Cananéia",
        "Canas",
        "Cândido Mota",
        "Cândido Rodrigues",
        "Canitar",
        "Capão Bonito",
        "Capela do Alto",
        "Capivari",
        "Caraguatatuba",
        "Carapicuíba",
        "Cardoso",
        "Casa Branca",
        "Cássia dos Coqueiros",
        "Castilho",
        "Catanduva",
        "Catiguá",
        "Cedral",
        "Cerqueira César",
        "Cerquilho",
        "Cesário Lange",
        "Charqueada",
        "Chavantes",
        "Clementina",
        "Colina",
        "Colômbia",
        "Conchal",
        "Conchas",
        "Cordeirópolis",
        "Coroados",
        "Coronel Macedo",
        "Corumbataí",
        "Cosmópolis",
        "Cosmorama",
        "Cotia",
        "Cravinhos",
        "Cristais Paulista",
        "Cruzália",
        "Cruzeiro",
        "Cubatão",
        "Cunha",
        "Descalvado",
        "Diadema",
        "Dirce Reis",
        "Divinolândia",
        "Dobrada",
        "Dois Córregos",
        "Dolcinópolis",
        "Dourado",
        "Dracena",
        "Duartina",
        "Dumont",
        "Echaporã",
        "Eldorado",
        "Elias Fausto",
        "Elisiário",
        "Embaúba",
        "Embu",
        "Embu-Guaçu",
        "Emilianópolis",
        "Engenheiro Coelho",
        "Espírito Santo do Pinhal",
        "Espírito Santo do Turvo",
        "Estiva Gerbi",
        "Estrela d'Oeste",
        "Estrela do Norte",
        "Euclides da Cunha Paulista",
        "Fartura",
        "Fernando Prestes",
        "Fernandópolis",
        "Fernão",
        "Ferraz de Vasconcelos",
        "Flora Rica",
        "Floreal",
        "Florínia",
        "Flórida Paulista",
        "Franca",
        "Francisco Morato",
        "Franco da Rocha",
        "Gabriel Monteiro",
        "Gália",
        "Garça",
        "Gastão Vidigal",
        "Gavião Peixoto",
        "General Salgado",
        "Getulina",
        "Glicério",
        "Guaiçara",
        "Guaimbê",
        "Guaíra",
        "Guapiaçu",
        "Guapiara",
        "Guará",
        "Guaraçaí",
        "Guaraci",
        "Guarani d'Oeste",
        "Guarantã",
        "Guararapes",
        "Guararema",
        "Guaratinguetá",
        "Guareí",
        "Guariba",
        "Guarujá",
        "Guatapará",
        "Guzolândia",
        "Herculândia",
        "Holambra",
        "Hortolândia",
        "Iacanga",
        "Iacri",
        "Iaras",
        "Ibaté",
        "Ibirá",
        "Ibirarema",
        "Ibitinga",
        "Ibiúna",
        "Icém",
        "Iepê",
        "Igaraçu do Tietê",
        "Igarapava",
        "Igaratá",
        "Iguape",
        "Ilha Comprida",
        "Ilha Solteira",
        "Ilhabela",
        "Indaiatuba",
        "Indiana",
        "Indiaporã",
        "Inúbia Paulista",
        "Ipauçu",
        "Iperó",
        "Ipeúna",
        "Ipiguá",
        "Iporanga",
        "Ipuã",
        "Iracemápolis",
        "Irapuã",
        "Irapuru",
        "Itaberá",
        "Itaí",
        "Itajobi",
        "Itaju",
        "Itanhaém",
        "Itaóca",
        "Itapecerica da Serra",
        "Itapetininga",
        "Itapeva",
        "Itapevi",
        "Itapira",
        "Itapirapuã Paulista",
        "Itápolis",
        "Itaporanga",
        "Itapuí",
        "Itapura",
        "Itaquaquecetuba",
        "Itararé",
        "Itariri",
        "Itatiba",
        "Itatinga",
        "Itirapina",
        "Itirapuã",
        "Itobi",
        "Itu",
        "Itupeva",
        "Ituverava",
        "Jaborandi",
        "Jaboticabal",
        "Jacareí",
        "Jaci",
        "Jacupiranga",
        "Jaguariúna",
        "Jales",
        "Jambeiro",
        "Jandira",
        "Jardinópolis",
        "Jarinu",
        "Jaú",
        "Jeriquara",
        "Joanópolis",
        "João Ramalho",
        "José Bonifácio",
        "Júlio Mesquita",
        "Jumirim",
        "Jundiaí",
        "Junqueirópolis",
        "Juquiá",
        "Juquitiba",
        "Lagoinha",
        "Laranjal Paulista",
        "Lavínia",
        "Lavrinhas",
        "Leme",
        "Lençóis Paulista",
        "Limeira",
        "Lindóia",
        "Lins",
        "Lorena",
        "Lourdes",
        "Louveira",
        "Lucélia",
        "Lucianópolis",
        "Luís Antônio",
        "Luiziânia",
        "Lupércio",
        "Lutécia",
        "Macatuba",
        "Macaubal",
        "Macedônia",
        "Magda",
        "Mairinque",
        "Mairiporã",
        "Manduri",
        "Marabá Paulista",
        "Maracaí",
        "Marapoama",
        "Mariápolis",
        "Marília",
        "Marinópolis",
        "Martinópolis",
        "Matão",
        "Mauá",
        "Mendonça",
        "Meridiano",
        "Mesópolis",
        "Miguelópolis",
        "Mineiros do Tietê",
        "Mira Estrela",
        "Miracatu",
        "Mirandópolis",
        "Mirante do Paranapanema",
        "Mirassol",
        "Mirassolândia",
        "Mococa",
        "Mogi das Cruzes",
        "Mogi-Guaçu",
        "Mogi-Mirim",
        "Mombuca",
        "Monções",
        "Mongaguá",
        "Monte Alegre do Sul",
        "Monte Alto",
        "Monte Aprazível",
        "Monte Azul Paulista",
        "Monte Castelo",
        "Monte Mor",
        "Monteiro Lobato",
        "Morro Agudo",
        "Morungaba",
        "Motuca",
        "Murutinga do Sul",
        "Nantes",
        "Narandiba",
        "Natividade da Serra",
        "Nazaré Paulista",
        "Neves Paulista",
        "Nhandeara",
        "Nipoã",
        "Nova Aliança",
        "Nova Campina",
        "Nova Canaã Paulista",
        "Nova Castilho",
        "Nova Europa",
        "Nova Granada",
        "Nova Guataporanga",
        "Nova Independência",
        "Nova Luzitânia",
        "Nova Odessa",
        "Novais",
        "Novo Horizonte",
        "Nuporanga",
        "Ocauçu",
        "Óleo",
        "Olímpia",
        "Onda Verde",
        "Oriente",
        "Orindiúva",
        "Orlândia",
        "Osasco",
        "Oscar Bressane",
        "Osvaldo Cruz",
        "Ourinhos",
        "Ouro Verde",
        "Ouroeste",
        "Pacaembu",
        "Palestina",
        "Palmares Paulista",
        "Palmeira d'Oeste",
        "Palmital",
        "Panorama",
        "Paraguaçu Paulista",
        "Paraibuna",
        "Paraíso",
        "Paranapanema",
        "Paranapuã",
        "Parapuã",
        "Pardinho",
        "Pariquera-Açu",
        "Parisi",
        "Patrocínio Paulista",
        "Paulicéia",
        "Paulínia",
        "Paulistânia",
        "Paulo de Faria",
        "Pederneiras",
        "Pedra Bela",
        "Pedranópolis",
        "Pedregulho",
        "Pedreira",
        "Pedrinhas Paulista",
        "Pedro de Toledo",
        "Penápolis",
        "Pereira Barreto",
        "Pereiras",
        "Peruíbe",
        "Piacatu",
        "Piedade",
        "Pilar do Sul",
        "Pindamonhangaba",
        "Pindorama",
        "Pinhalzinho",
        "Piquerobi",
        "Piquete",
        "Piracaia",
        "Piracicaba",
        "Piraju",
        "Pirajuí",
        "Pirangi",
        "Pirapora do Bom Jesus",
        "Pirapozinho",
        "Pirassununga",
        "Piratininga",
        "Pitangueiras",
        "Planalto",
        "Platina",
        "Poá",
        "Poloni",
        "Pompéia",
        "Pongaí",
        "Pontal",
        "Pontalinda",
        "Pontes Gestal",
        "Populina",
        "Porangaba",
        "Porto Feliz",
        "Porto Ferreira",
        "Potim",
        "Potirendaba",
        "Pracinha",
        "Pradópolis",
        "Praia Grande",
        "Pratânia",
        "Presidente Alves",
        "Presidente Bernardes",
        "Presidente Epitácio",
        "Presidente Prudente",
        "Presidente Venceslau",
        "Promissão",
        "Quadra",
        "Quatá",
        "Queiroz",
        "Queluz",
        "Quintana",
        "Rafard",
        "Rancharia",
        "Redenção da Serra",
        "Regente Feijó",
        "Reginópolis",
        "Registro",
        "Restinga",
        "Ribeira",
        "Ribeirão Bonito",
        "Ribeirão Branco",
        "Ribeirão Corrente",
        "Ribeirão do Sul",
        "Ribeirão dos Índios",
        "Ribeirão Grande",
        "Ribeirão Pires",
        "Ribeirão Preto",
        "Rifaina",
        "Rincão",
        "Rinópolis",
        "Rio Claro",
        "Rio das Pedras",
        "Rio Grande da Serra",
        "Riolândia",
        "Riversul",
        "Rosana",
        "Roseira",
        "Rubiácea",
        "Rubinéia",
        "Sabino",
        "Sagres",
        "Sales",
        "Sales Oliveira",
        "Salesópolis",
        "Salmourão",
        "Saltinho",
        "Salto",
        "Salto de Pirapora",
        "Salto Grande",
        "Sandovalina",
        "Santa Adélia",
        "Santa Albertina",
        "Santa Bárbara d'Oeste",
        "Santa Branca",
        "Santa Clara d'Oeste",
        "Santa Cruz da Conceição",
        "Santa Cruz da Esperança",
        "Santa Cruz das Palmeiras",
        "Santa Cruz do Rio Pardo",
        "Santa Ernestina",
        "Santa Fé do Sul",
        "Santa Gertrudes",
        "Santa Isabel",
        "Santa Lúcia",
        "Santa Maria da Serra",
        "Santa Mercedes",
        "Santa Rita d'Oeste",
        "Santa Rita do Passa Quatro",
        "Santa Rosa de Viterbo",
        "Santa Salete",
        "Santana da Ponte Pensa",
        "Santana de Parnaíba",
        "Santo Anastácio",
        "Santo Antônio da Alegria",
        "Santo Antônio de Posse",
        "Santo Antônio do Aracanguá",
        "Santo Antônio do Jardim",
        "Santo Antônio do Pinhal",
        "Santo Expedito",
        "Santópolis do Aguapeí",
        "Santos",
        "São Bento do Sapucaí",
        "São Caetano do Sul",
        "São Carlos",
        "São Francisco",
        "São João da Boa Vista",
        "São João das Duas Pontes",
        "São João de Iracema",
        "São João do Pau d'Alho",
        "São Joaquim da Barra",
        "São José da Bela Vista",
        "São José do Barreiro",
        "São José do Rio Pardo",
        "São José do Rio Preto",
        "São José dos Campos",
        "São Lourenço da Serra",
        "São Luís do Paraitinga",
        "São Manuel",
        "São Miguel Arcanjo",
        "São Paulo",
        "São Pedro",
        "São Pedro do Turvo",
        "São Roque",
        "São Sebastião",
        "São Sebastião da Grama",
        "São Simão",
        "São Vicente",
        "Sarapuí",
        "Sarutaiá",
        "Sebastianópolis do Sul",
        "Serra Azul",
        "Serra Negra",
        "Serrana",
        "Sertãozinho",
        "Sete Barras",
        "Severínia",
        "Silveiras",
        "Socorro",
        "Sorocaba",
        "Sud Mennucci",
        "Sumaré",
        "Suzanápolis",
        "Suzano",
        "Tabapuã",
        "Tabatinga",
        "Taboão da Serra",
        "Taciba",
        "Taguaí",
        "Taiaçu",
        "Taiúva",
        "Tambaú",
        "Tanabi",
        "Tapiraí",
        "Tapiratiba",
        "Taquaral",
        "Taquaritinga",
        "Taquarituba",
        "Taquarivaí",
        "Tarabai",
        "Tarumã",
        "Tatuí",
        "Taubaté",
        "Tejupá",
        "Teodoro Sampaio",
        "Terra Roxa",
        "Tietê",
        "Timburi",
        "Torre de Pedra",
        "Torrinha",
        "Trabiju",
        "Tremembé",
        "Três Fronteiras",
        "Tuiuti",
        "Tupã",
        "Tupi Paulista",
        "Turiúba",
        "Turmalina",
        "Ubarana",
        "Ubatuba",
        "Ubirajara",
        "Uchoa",
        "União Paulista",
        "Urânia",
        "Uru",
        "Urupês",
        "Valentim Gentil",
        "Valinhos",
        "Valparaíso",
        "Vargem",
        "Vargem Grande do Sul",
        "Vargem Grande Paulista",
        "Várzea Paulista",
        "Vera Cruz",
        "Vinhedo",
        "Viradouro",
        "Vista Alegre do Alto",
        "Vitória Brasil",
        "Votorantim",
        "Votuporanga",
        "Zacarias"  ];

    let objCities = objCitiesList.filter((c: string) => {
        return c.toLowerCase().trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').indexOf(cityFilter.toLowerCase().trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) > -1;
    }).map((c: string) => {
        return <div className="gender-item" key={objCitiesList.indexOf(c)}>
            <button className="btn btn-outline btn-full" onClick={() => setCity(c)}>{c}</button>
        </div>;
    }).slice(0, 5);

    return (
        <>
            <Header step={5} total={15} title="Endereço - Cidade" previous="#/genero"></Header>
            <div className="chat-container">
                <div className="chat">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 d-flex flex-column align-items-stretch justify-content-between">

                                <div className="chat-item chat-item-user">
                                    <img src="images/ico-chat-user.svg" alt="Usuário" />
                                    <div className="chat-item-content">
                                        <p>{gender}</p>
                                    </div>
                                </div>

                                <div className="chat-item">
                                    <img src="images/ico-chat-amarelinho.svg" alt="Amarelinho" />
                                    <div className="chat-item-content">
                                        <p>
                                            <Typewriter
                                                    onInit={(typewriter) => {
                                                        typewriter
                                                            .changeDelay(15)
                                                            .typeString('Agora eu preciso saber mais sobre seu endereço. <strong>Vamos começar pela cidade</strong>.')
                                                            .callFunction(() => {
                                                                setTyped(true)
                                                            })
                                                            .start();
                                                }} />

                                            
                                        </p>
                                    </div>
                                </div>

                                { typed &&
                                <div className="gender-list">
                                {
                                    objCities.map((objCity: any) => {
                                        return objCity;
                                    })
                                }
                                </div>
                                }

                            </div>
                        </div>
                    </div>
                </div>
                <footer className="footer-answer">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="footer-answer-holder d-flex align-items-center justify-content-between">
                                    <input type="text" name="" id="" placeholder="Pesquise uma cidade" onClick={() => document.location = '#/cidade-pesquisa' } />
                                    {
                                        cityFilter.length === 0 &&
                                        <button className="btn-submit" disabled={true}>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M17.1527 15.0943H16.0686L15.6844 14.7238C17.0292 13.1595 17.8388 11.1286 17.8388 8.91938C17.8388 3.99314 13.8456 0 8.91938 0C3.99314 0 0 3.99314 0 8.91938C0 13.8456 3.99314 17.8388 8.91938 17.8388C11.1286 17.8388 13.1595 17.0292 14.7238 15.6844L15.0943 16.0686V17.1527L21.9554 24L24 21.9554L17.1527 15.0943ZM8.91938 15.0943C5.50257 15.0943 2.74443 12.3362 2.74443 8.91938C2.74443 5.50257 5.50257 2.74443 8.91938 2.74443C12.3362 2.74443 15.0943 5.50257 15.0943 8.91938C15.0943 12.3362 12.3362 15.0943 8.91938 15.0943Z" fill="#6F5192"/>
                                            </svg>
                                        </button>
                                    }
                                    {
                                        cityFilter.length > 0 &&
                                        <button className="btn-submit" onClick={() => setCityFilter(cityFilter)}>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M17.1527 15.0943H16.0686L15.6844 14.7238C17.0292 13.1595 17.8388 11.1286 17.8388 8.91938C17.8388 3.99314 13.8456 0 8.91938 0C3.99314 0 0 3.99314 0 8.91938C0 13.8456 3.99314 17.8388 8.91938 17.8388C11.1286 17.8388 13.1595 17.0292 14.7238 15.6844L15.0943 16.0686V17.1527L21.9554 24L24 21.9554L17.1527 15.0943ZM8.91938 15.0943C5.50257 15.0943 2.74443 12.3362 2.74443 8.91938C2.74443 5.50257 5.50257 2.74443 8.91938 2.74443C12.3362 2.74443 15.0943 5.50257 15.0943 8.91938C15.0943 12.3362 12.3362 15.0943 8.91938 15.0943Z" fill="#fff"/>
                                            </svg>
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </>);
}
